import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'oms-glass-background',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './oms-glass-background.component.html',
  styleUrl: './oms-glass-background.component.scss',
})
export class OmsGlassBackgroundComponent {
  /**
   * Padding top in pixels (default: 56px)
   */
  @Input() paddingTop: number = 56;

  /**
   * Padding bottom in pixels (default: 32px)
   */
  @Input() paddingBottom: number = 32;

  /**
   * Padding left/right in pixels (default: 32px)
   */
  @Input() paddingX: number = 32;

  /**
   * Border radius in pixels (default: 12px)
   */
  @Input() borderRadius: number = 12;

  /**
   * Background opacity (0-1, default: 0.48)
   */
  @Input() backgroundOpacity: number = 0.48;

  /**
   * Custom CSS class for additional styling
   */
  @Input() customClass: string = '';
}
